// Store global para disparar toasts desde cualquier parte de la app sin
// tener que montar estado local en cada componente. Reemplaza por completo
// a notification.*/message.* de antd — no los uses en ningun modulo nuevo.
let listeners = [];
let uid = 0;

export function subscribeToast(listener) {
  listeners.push(listener);
  return () => {
    listeners = listeners.filter((l) => l !== listener);
  };
}

function emit(type, msg, opts = {}) {
  uid += 1;
  const event = { id: uid, type, msg, action: opts.action || null, delay: opts.delay };
  listeners.forEach((listener) => listener(event));
}

// opts opcional: { action: { label, onClick }, delay }
export const toast = {
  success: (msg, opts) => emit("success", msg, opts),
  error: (msg, opts) => emit("error", msg, opts),
  warning: (msg, opts) => emit("warning", msg, opts),
  info: (msg, opts) => emit("info", msg, opts),
};
